module.exports = __webpack_public_path__ + "static/media/016.f387e3cc.jpg";